import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Cloud = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.329 12.398C23.847 8.55 20.162 6 16 6C13.505 6 11.115 6.924 9.271 8.603C7.615 10.111 6.521 12.111 6.145 14.296C3.705 15.091 2 17.385 2 20.001C2 23.309 4.692 26.001 8 26.001H23C26.86 26.001 30 22.861 30 19.001C30 16.019 28.105 13.377 25.329 12.399V12.398ZM23 24H8C5.794 24 4 22.206 4 20C4 18.092 5.361 16.441 7.237 16.075C7.67 15.99 7.996 15.632 8.04 15.193C8.45 11.092 11.872 8 16 8C18.908 8 21.524 9.557 22.93 12.002C19.102 12.04 16 15.164 16 19C16 19.552 16.448 20 17 20C17.552 20 18 19.552 18 19C18 16.243 20.243 14 23 14C25.764 14 28 16.236 28 19C28 21.757 25.757 24 23 24Z" />
	</svg>
);

export default Cloud;
